<template>
    <div>
        <div class="card mb-3" id="cost">
            <div class="card-header headline cost">
                <h2 class="text-white d-inline" v-if="transactionType === 'payment'">پرداخت به هزینه</h2>
                <h2 class="text-white d-inline" v-if="transactionType === 'receive'">دریافت از هزینه</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mt-5" v-if="costs.length < 1">
                        <h3 class="text-center no-item-alert">هزینه ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in costs">
                        <div class="card shadow" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12 mt-3">
                                    <h4 class="text-center">{{item.outSourceName}}</h4>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="costs.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getcosts">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loadings">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && costs.length < dataCount" class="col-lg-12 text-center mb-3" @click="getcosts">
                        <button class="btn btn-success">نمایش موارد بیشتر</button>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="modal fade" id="cost-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="transactionType === 'payment'" class="modal-title text-white">پرداخت به {{cost.outSourceName}}</h5>
                        <h5 v-if="transactionType === 'receive'" class="modal-title text-white">دریافت از {{cost.outSourceName}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">موجودی اولیه</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="opening.price">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import EventBus from "../../_framework/event-bus.js";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(()=> {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'transaction-cost',
        components: {},
        data() {
            return {
                costs: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 8
                },
                opening: {
                    code: "",
                    price: 0,
                    isDebtor: true,
                    voucherId: 0,
                },
                params: {
                    mode: 'create'
                },
                searchString: "",
                transactionType: "",
                transaction: {
                    outSourceName: "",
                    fromCode: "",
                    toCode: "",
                    code: "",
                    price: 0,
                    check: {
                        checkNumber: "",
                        checkDate: "",
                        checkPersianDate: "",
                        bankName: "",
                        branchName: "",
                        branchCode: ""
                    }
                },
                dataCount: 0,

                autoload: false
            }
        } ,
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.transactionType = this.$parent.type;
            EventBus.$on('transactionType', value => {
                this.transactionType = value;
            });
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.costs = response.data.data;
                this.dataCount = response.data.count;
                $("#loadings").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.costs.length < this.dataCount) {
                        $("#loading").show();
                        this.getcosts();
                    }
                });
            }
        },
        methods: {
            getcosts() {
                this.queryParams.pageIndex++;
                $("#loadings").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.costs.push.apply(this.costs, response.data.data);
                    $("#loadings").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onCardClicked(index) {
                if (this.transactionType === 'payment') {
                    this.transaction.outSourceName = this.costs[index].outSourceName;
                    if (this.transactionType === 'payment') {
                        this.transaction.toCode = this.costs[index].code;
                    } else {
                        this.transaction.fromCode = this.costs[index].code;
                    }
                    this.$router.push({
                        name: 'transaction-payment',
                        params: {
                            transaction: this.transaction,
                            type: this.transactionType
                        }
                    });
                } else {
                    this.$noty.warning("هزینه فقط قابل پرداخت می باشد.");
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            next();
        },
    }
</script>